import { createContext, useContext } from 'react';

import { defaultTranslations } from '../constants/translations';

export type TranslationsContextState = typeof defaultTranslations;

export const TranslationsContext =
  createContext<TranslationsContextState>(defaultTranslations);

export const useTranslationsContext = () => useContext(TranslationsContext);
